import { render, staticRenderFns } from "./Preguntas.vue?vue&type=template&id=46b8540f&"
import script from "./Preguntas.vue?vue&type=script&lang=js&"
export * from "./Preguntas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports